<template>
  <div class="overflow-x-auto rounded-lg border border-gray-200">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-slate-50">
        <tr>
          <th v-if="selectable" class="px-4 py-3 w-10"></th>
          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Type
          </th>
          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Description
          </th>
          <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            Price
          </th>
          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Unit
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr
          v-for="entry in entries"
          :key="entry.type"
          :class="[
            selectable ? 'cursor-pointer hover:bg-slate-50' : '',
            isSelected(entry) ? 'bg-indigo-50' : '',
          ]"
          @click="selectable && $emit('select', entry)"
        >
          <td v-if="selectable" class="px-4 py-3">
            <span
              class="h-4 w-4 rounded-full flex items-center justify-center ring-2 ring-offset-2"
              :class="isSelected(entry) ? 'bg-indigo-600 ring-indigo-300' : 'bg-white ring-gray-300'"
            >
              <span v-if="isSelected(entry)" class="h-1.5 w-1.5 rounded-full bg-white"></span>
            </span>
          </td>
          <td class="px-4 py-3 text-sm font-medium text-gray-900 whitespace-nowrap">
            {{ entry.type }}
          </td>
          <td class="px-4 py-3 text-sm text-gray-600 max-w-md">
            {{ entry.description || "—" }}
          </td>
          <td class="px-4 py-3 text-sm font-medium text-gray-900 text-right whitespace-nowrap">
            <span v-if="entry.price === null || entry.price === undefined" class="text-indigo-600">
              On request
            </span>
            <span v-else-if="entry.price === 0" class="text-emerald-600">Free</span>
            <span v-else v-currency="entry.price">{{ entry.price }}</span>
          </td>
          <td class="px-4 py-3 text-sm text-gray-500 whitespace-nowrap">{{ entry.unit }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "PriceTable",
  props: {
    entries: { type: Array, default: () => [] },
    selectable: { type: Boolean, default: false },
    selected: { type: Object, default: null },
  },
  emits: ["select"],
  methods: {
    isSelected(entry) {
      return this.selectable && this.selected && this.selected.type === entry.type;
    },
  },
};
</script>
